module.exports = __webpack_public_path__ + "8a0211a85f69e64609f6f5169bad02ca.svg";